import { DEFAULT_SORT_VALUE } from "../../constants/shopConstants";

export const extractCurrentPageItems = (
  items: any[],
  currentPage: number,
  itemsPerPage: number,
) => {
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  return items.length > 0 ? items.slice(indexOfFirstItem, indexOfLastItem) : [];
};

export const sortProducts = (arr: any, sortByValue: string = DEFAULT_SORT_VALUE) => {
  return arr.sort((a: any, b: any) => {

    if (sortByValue === 'discounted') {
		
      const aHasHyphen = a.price.includes('-');
      const bHasHyphen = b.price.includes('-');
  
      if (aHasHyphen && !bHasHyphen) return -1;
      if (!aHasHyphen && bHasHyphen) return 1;
  
      const aDiscounted = removeDollarSignAndConvertToNumber(a.price) < removeDollarSignAndConvertToNumber(a.regularPrice);
      const bDiscounted = removeDollarSignAndConvertToNumber(b.price) < removeDollarSignAndConvertToNumber(b.regularPrice);
    
      if (aDiscounted && !bDiscounted) return -1;
      if (!aDiscounted && bDiscounted) return 1;
      if (aDiscounted && bDiscounted) {
        const aDiscount = calculateDiscountPercentage(a.regularPrice, a.price);
        const bDiscount = calculateDiscountPercentage(b.regularPrice, b.price);
      //   @ts-ignore
        return bDiscount - aDiscount;
      }
      return 0;
    }

    if (sortByValue == "a-z") {
      return a.name.localeCompare(b.name);
    }

    if (sortByValue == "z-a") {
      return b.name.localeCompare(a.name);
    }

    if (sortByValue == "priceASC") {
      const aPrice = Number(a.price?.replace(/[^0-9.-]+/g, ""));
      const bPrice = Number(b.price?.replace(/[^0-9.-]+/g, ""));

      return aPrice - bPrice;
    }

    if (sortByValue == "priceDESC") {
      const aPrice = Number(a.price?.replace(/[^0-9.-]+/g, ""));
      const bPrice = Number(b.price?.replace(/[^0-9.-]+/g, ""));

      return bPrice - aPrice;
    }
  });
};

export const filterByBrand = (products: any, excludedBrands: any) => {
  if (!excludedBrands || excludedBrands.length === 0) {
    return products;
  }

  const filteredProducts = products.filter((product: any) => {
    const productBrandSlugs = product.productTags.nodes.map(
      (node: any) => node.slug,
    );

    return productBrandSlugs.some((slug: any) => excludedBrands.includes(slug));
  });

  return filteredProducts;
};

export const filterByIngredients = (products: any, ingredients: any) => {
  if (!ingredients || ingredients.length === 0) {
    return products;
  }

  const filteredProducts = products.filter((product: any) => {
    const productBrandSlugs = product.allPaActiveIngredient.nodes.map(
      (node: any) => node.slug,
    );
    return productBrandSlugs.some((slug: any) => ingredients.includes(slug));
  });

  return filteredProducts;
};

export const filterProductsByPrice = (
  products: any[],
  minPrice: any,
  maxPrice: any,
) => {
  let filteredProducts: any[] = products;

  const minPriceExists = !!Number(minPrice);
  const maxPriceExists = !!Number(maxPrice);

  if (minPriceExists && maxPriceExists) {
    filteredProducts = filteredProducts.filter(
      (item: any) =>
        Number(item.price?.replace(/[^0-9.-]+/g, "")) >= Number(minPrice) &&
        Number(item.price?.replace(/[^0-9.-]+/g, "")) <= Number(maxPrice),
    );
  } else if (minPriceExists) {
    filteredProducts = filteredProducts.filter(
      (item: any) =>
        Number(item.price?.replace(/[^0-9.-]+/g, "")) >= Number(minPrice),
    );
  } else if (maxPriceExists) {
    filteredProducts = filteredProducts.filter(
      (item: any) =>
        Number(item.price?.replace(/[^0-9.-]+/g, "")) <= Number(maxPrice),
    );
  }

  return filteredProducts;
};

export const updateBlogURLParams = (params: any) => {
  const newURL = new URL(window.location.href);

  for (const key in params) {
    if (key === "page") {
      if (params[key] == 1) {
        newURL.searchParams.delete(key);
      } else {
        newURL.searchParams.set(key, params[key]);
      }
    } else {
      newURL.searchParams.set(key, params[key]);
    }
  }

  // Push the updated URL to the browser's history
  window.history.pushState({}, "", newURL.toString());
};

export const updateShopURLParams = (params: any) => {
  const newURL = new URL(window.location.href);

  for (const key in params) {
    if (key === "brands") {
      const brandQueryString = params[key].join(",");

      if (!brandQueryString) {
        newURL.searchParams.delete(key);
      } else {
        newURL.searchParams.set(key, brandQueryString);
      }
    } else if (key === "ingredients") {
      const ingredientQueryString = params[key].join(",");

      if (!ingredientQueryString) {
        newURL.searchParams.delete(key);
      } else {
        newURL.searchParams.set(key, ingredientQueryString);
      }
    } else if (key === "page") {
      if (params[key] == 1) {
        newURL.searchParams.delete(key);
      } else {
        newURL.searchParams.set(key, params[key]);
      }
    } else if (key === "sort") {
      if (!params[key] || params[key] == "discounted") {
        newURL.searchParams.delete(key);
      } else {
        newURL.searchParams.set(key, params[key]);
      }
    } else if (key === "minPrice") {
      if (!params[key] || params[key] == 0) {
        newURL.searchParams.delete(key);
      } else {
        newURL.searchParams.set(key, params[key]);
      }
    } else if (key === "maxPrice") {
      if (!params[key] || params[key] == 0) {
        newURL.searchParams.delete(key);
      } else {
        newURL.searchParams.set(key, params[key]);
      }
    } else {
      newURL.searchParams.set(key, params[key]);
    }
  }

  // Push the updated URL to the browser's history
  window.history.pushState({}, "", newURL.toString());
};

export const parseHeaderBrands = (brands: any[]) => {
  const groupedItems = brands.reduce((acc, item) => {
    const firstChar = item.name.charAt(0).toUpperCase();
    if (/^[A-Z]/.test(firstChar)) {
      // Items starting with a letter (A-Z)
      if (!acc[firstChar]) {
        acc[firstChar] = { startsWith: firstChar, items: [] };
      }
      acc[firstChar].items.push(item);
    } else if (/^[0-9]/.test(firstChar)) {
      // Items starting with a digit (0-9)
      if (!acc["0-9"]) {
        acc["0-9"] = { startsWith: "0-9", items: [] };
      }
      acc["0-9"].items.push(item);
    }
    return acc;
  }, {});

  // Convert the grouped items object to an array of groups
  const groupedItemsArray = Object.values(groupedItems);

  return groupedItemsArray;
};

function removeDollarSignAndConvertToNumber(price: any) {
  // Remove commas and dollar sign, then convert to a number
  return parseFloat(price?.replace(/[$,]/g, ""));
}

export const getLowestAndHighestPrices = (products: any): any => {
  // Initialize variables to keep track of the lowest and highest prices
  let lowestPrice = Number.POSITIVE_INFINITY;
  let highestPrice = Number.NEGATIVE_INFINITY;

  // Iterate through the array of objects to find the lowest and highest prices
  for (const product of products) {
    const price = removeDollarSignAndConvertToNumber(product.price);
    if (price < lowestPrice) {
      lowestPrice = Math.floor(price); // Round down for the lowest price
    }
    if (price > highestPrice) {
      highestPrice = Math.ceil(price); // Round up for the highest price
    }
  }

  return { lowestPrice, highestPrice };
};

export const generatePaginationArray = (
  numberOfPages: number,
  currentPage: number,
) => {
  const maxVisiblePages = 7;
  const items = [];

  // Always show the first page
  items.push({ type: "pageNumber", number: 1 });

  if (numberOfPages <= maxVisiblePages) {
    // If there are fewer or equal to 7 pages, display all pages as page numbers
    for (let i = 2; i <= numberOfPages - 1; i++) {
      items.push({ type: "pageNumber", number: i });
    }
  } else {
    const leftOffset = 1; // Number of pages to the left of the current page
    const rightOffset = 1; // Number of pages to the right of the current page

    // Determine the range of pages to display as page numbers
    let startPage = currentPage - leftOffset;
    let endPage = currentPage + rightOffset;

    // Ensure the range is within bounds
    if (startPage < 4) {
      startPage = 2;
      endPage = maxVisiblePages - 2;
    } else if (endPage > numberOfPages - 3) {
      startPage = numberOfPages - maxVisiblePages + 3;
      endPage = numberOfPages - 1;
    }

    // Add three dots if necessary
    if (startPage >= 4) {
      items.push({ type: "threeDots", number: undefined });
    }

    for (let i = startPage; i <= endPage; i++) {
      items.push({ type: "pageNumber", number: i });
    }

    if (endPage < numberOfPages - 1) {
      items.push({ type: "threeDots", number: undefined });
    }
  }

  // Always show the last page
  items.push({ type: "pageNumber", number: numberOfPages });

  return items;
};

export const getProductPrice = (
  quantity: any,
  tierPrice: any,
  price: string | number,
) => {
  if (!tierPrice || !tierPrice.tierPrice) {
    return removeDollarSignAndConvertToNumber(price);
  }

  if (quantity >= 21) {
    return tierPrice?.tierPrice?.[0]?.price4;
  } else if (quantity >= 11) {
    return tierPrice?.tierPrice?.[0]?.price3;
  } else if (quantity >= 3) {
    return tierPrice?.tierPrice?.[0]?.price2;
  }
  return tierPrice?.tierPrice?.[0]?.price;
};

export function calculateDiscountPercentage(
  regularPrice: number,
  discountedPrice: number,
) {
  if (regularPrice < 0 || discountedPrice < 0) {
    return "-";
  }

  const discountAmount = regularPrice - discountedPrice;

  const discountPercentage = (discountAmount / regularPrice) * 100;

  const roundedDiscountPercentage = Number(discountPercentage.toFixed(2));

  return roundedDiscountPercentage;
}
